"use client";

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";

import styles from "./courses.module.scss";
import Components from "@/components";
import useApi from "@/hooks/useApi";
import sk from "@/skeletons";
import api from "@/api";

function LatestVideos({ gap, vidPerView }) {
  const user = useSelector((state) => state?.user?.users);
  const [recommended, setRecommended] = useState([]);
  const router = useRouter();

  const { data: recommendedvideo, request: loadRecommendedVideo } = useApi(
    api.getrecommendedvideos
  );

  useEffect(() => {
    loadRecommendedVideo(1, 10);
  }, [user]);

  useEffect(() => {
    setRecommended(recommendedvideo);
  }, [recommendedvideo]);

  return (
    <>
      <section className={styles["hm-category-rows"]}>
        <header className={styles["title"]}>
          <h1>Latest Videos</h1>
        </header>
        <div
          className={`${styles["hm-category-videos"]} ${
            !recommended?.data?.length ? styles["loading"] : ""
          }`}
        >
          <button
            className={`${styles["slider-nav-button"]} ${styles["prev"]}`}
            id="CP_Latest_Video_Left_Btn"
          >
            <Icon icon="mdi:keyboard-arrow-left" />
          </button>
          {recommended?.data?.length ? (
            <Swiper
              slidesPerView={vidPerView}
              spaceBetween={gap}
              freeMode={true}
              pagination={false}
              modules={[FreeMode, Navigation]}
              navigation={{
                prevEl: "#CP_Latest_Video_Left_Btn",
                nextEl: "#CP_Latest_Video_Right_Btn",
              }}
              className={styles["latestvideo-swiper"]}
            >
              {recommended.data.map((video, i) => (
                <SwiperSlide key={i}>
                  <Components.CourseCard
                    type="video"
                    id={video?._id}
                    image={video?.thumbnailImage}
                    seoTitle={video?.seoTitle}
                    tag={video?.categories}
                    viewCount={video?.views}
                    title={video?.title}
                    description={video?.about}
                    creatorInfo={{
                      id: video?.creatorInfo?.[0]?._id,
                      name: video?.creatorInfo?.[0]?.name,
                      username: video?.creatorInfo?.[0]?.username,
                      image: video?.creatorInfo?.[0]?.profileImage,
                    }}
                  />
                </SwiperSlide>
              ))}
              <SwiperSlide
                className={styles["view-all"]}
                onClick={() => router.push("/videos")}
              >
                <Components.ViewAllCard />
              </SwiperSlide>
            </Swiper>
          ) : (
            <sk.RowCardSkeleton number={vidPerView} />
          )}
          <button
            className={`${styles["slider-nav-button"]} ${styles["next"]}`}
            id="CP_Latest_Video_Right_Btn"
          >
            <Icon icon="mdi:keyboard-arrow-right" />
          </button>
        </div>
      </section>
    </>
  );
}

export default Components.CardWrapper(LatestVideos);
